export default "__VITE_ASSET__ZS4b$w2P__"